// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcfb6db6","455":"8bdbe065","673":"8b480ccb","977":"209655a0"}[chunkId] + ".chunk.js";
};